// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import autoCompleteSharedStyles from "@west/App/SharedStyles/AutoCompleteSharedStyles";
import { autocompleteProductsStyles } from "@west/Overrides/Widgets/Header/AutocompleteProducts";
import { color, ellipsis } from "@west/XDL/Utilities";
import { css } from "styled-components";

autocompleteProductsStyles.container = {
    ...autoCompleteSharedStyles.container,
};

autocompleteProductsStyles.headerContainer = {
    ...autoCompleteSharedStyles.headerContainer,
};

autocompleteProductsStyles.headerText = {
    ...autoCompleteSharedStyles.headerText,
};

autocompleteProductsStyles.viewAllLink = {
    ...autoCompleteSharedStyles.viewAllLink,
};

autocompleteProductsStyles.productContainer = {
    css: css`
        display: flex;
        gap: 12px;
    `,
};

autocompleteProductsStyles.imageGridItem = {
    css: css`
        cursor: pointer;
        width: 72px;
        height: 72px;
    `,
};

autocompleteProductsStyles.image = {
    width: "72px",
    height: "72px",
    css: css`
        max-width: 100%;
        max-height: 100%;

        img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};

autocompleteProductsStyles.infoGridItem = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        justify-content: space-between;
    `,
};

autocompleteProductsStyles.descriptionContainer = {
    css: css`
        height: 32px;
    `,
};

autocompleteProductsStyles.titleLink = {
    color: "text.main",
    typographyProps: {
        size: 14,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 16px;
            ${ellipsis(2)}
        `,
    },
};

autocompleteProductsStyles.productInfoContainer = {
    css: css`
        display: flex;
        gap: 8px;
        margin-bottom: 16px;
    `,
};

autocompleteProductsStyles.brandLink = {
    typographyProps: {
        size: 12,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 14px;
        `,
    },
    css: css`
        padding-right: 8px;
        position: relative;

        &.add-separate:after {
            content: "";
            width: 1px;
            height: 100%;
            background: ${color("common.border")};
            position: absolute;
            left: 100%;
        }
    `,
};

autocompleteProductsStyles.erpNumberText = {
    size: 12,
    weight: "normal",
    css: css`
        letter-spacing: 0;
        line-height: 16px;
    `,
};
